import axios, { AxiosRequestConfig } from "axios";
import services from "../services";
axios.defaults.withCredentials = true;
const BASE_URL = process.env.REACT_APP_API_URL || "/";

interface VerbParamsInterface {
  url: string;
  body?: any;
  config?: AxiosRequestConfig;
}

const getConfig = async () => {
  const token = services.auth.getToken() || "";

  return {
    baseURL: BASE_URL,
    ...(token && { headers: { authorization: `Bearer ${token}` } }),
  };
};

const mergeConfig = async (config: AxiosRequestConfig = {}): Promise<AxiosRequestConfig> => {
  const defaultConfig = await getConfig();
  return {
    ...defaultConfig,
    ...config,
    headers: {
      ...defaultConfig.headers,
      ...config.headers,
    },
  };
};

const Get = async ({ url, config = {} }: VerbParamsInterface) => {
  const mergedConfig = await mergeConfig(config);
  const { data } = await axios.get(url, mergedConfig);
  return data;
};



const Post = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const mergedConfig = await mergeConfig(config);
  const { data } = await axios.post(url, body, mergedConfig);
  return data;
};

const Put = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const mergedConfig = await mergeConfig(config);
  const { data } = await axios.put(url, body, mergedConfig);
  return data;
};

const Del = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const mergedConfig = await mergeConfig({ ...config, data: body });
  const { data } = await axios.delete(url, mergedConfig);
  return data;
};

const Patch = async ({ url, body = {}, config = {} }: VerbParamsInterface) => {
  const mergedConfig = await mergeConfig(config);
  const { data } = await axios.patch(url, body, mergedConfig);
  return data;
};

const actions = {
  Get,
  Post,
  Put,
  Del,
  Patch,
};

export default actions;
